import { FC } from 'react';
import { Table, Form } from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';

import { RsInputSize } from 'components/Rsuite/Input';
import { useTableSort } from 'components/Rsuite/Table';

import { BlurNumberInput } from '../BlurNumberInput';
import {
  ManualKeywordProperty,
  ManualKeywordType,
  MANUAL_UNIQUE_KEY,
} from 'core/rtbCampaign/singlePage/keyword';
import styles from './readyKeywordTable.module.scss';

import { useBidRange } from '../../../Hooks/useBidRange';

interface ReadyKeywordTableProps {
  data: ManualKeywordType[];
  onBidChange: (uniqueKey: string, newPrice: number) => void;
  onDelete: (uniqueKey: string) => void;
}

export const ReadyKeywordTable: FC<ReadyKeywordTableProps> = ({
  data,
  onBidChange,
  onDelete,
}) => {
  const bidRange = useBidRange();
  const { sortedData, sortColumn, sortType, handleSortColumn } =
    useTableSort(data);
  return (
    <Table
      data={sortedData}
      className={styles.ReadyKeywordTable}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={handleSortColumn}
      shouldUpdateScroll={false}
      virtualized
      fillHeight
    >
      <Table.Column width={140} fixed sortable fullText>
        <Table.HeaderCell>關鍵字</Table.HeaderCell>
        <Table.Cell dataKey={ManualKeywordProperty.KEYWORD} />
      </Table.Column>
      <Table.Column width={140} sortable>
        <Table.HeaderCell>點擊出價</Table.HeaderCell>
        <Table.Cell
          dataKey={ManualKeywordProperty.PRICE}
          className={styles['bid-price-cell']}
        >
          {(item) => (
            <div className='relative'>
              <BlurNumberInput
                key={item[MANUAL_UNIQUE_KEY]}
                num={item[ManualKeywordProperty.PRICE]}
                onChange={(newBid) =>
                  onBidChange(item[MANUAL_UNIQUE_KEY], newBid)
                }
                size={RsInputSize.SMALL}
              />
              <Form.ErrorMessage
                show={item[ManualKeywordProperty.PRICE] <= 0}
                placement='leftStart'
              >
                {`金額請高於 0 元以上哦!`}
              </Form.ErrorMessage>
              <Form.ErrorMessage
                show={item[ManualKeywordProperty.PRICE] > bidRange[1]}
                placement='leftStart'
              >
                {`關鍵字出價需低於 ${bidRange[1]} 元`}
              </Form.ErrorMessage>
            </div>
          )}
        </Table.Cell>
      </Table.Column>
      <Table.Column width={60} align='center'>
        <Table.HeaderCell>操作</Table.HeaderCell>
        <Table.Cell>
          {(item) => (
            <TrashIcon
              className='cursor-pointer'
              onClick={() => onDelete(item[MANUAL_UNIQUE_KEY])}
            />
          )}
        </Table.Cell>
      </Table.Column>
    </Table>
  );
};
